import React from "react";
import { Container } from "@material-ui/core";
const SiteHeader = props => (
  <Container maxWidth="sm">
    <img src="https://images.ctfassets.net/cdyxtpbavd4i/7c2yrSNP9gINg5DSsZYt0n/4e969d20d8dfa4fb666d4067bd38a008/AdultTime_FinalLogo_Update2019.svg" alt="Adult Time"/>
  </Container>
);

export default SiteHeader;
